export default {
	notes: {
		visibleUntil: 'sichtbar bis',
		visibleFor: 'Sichtbar für',
		title: 'Neuigkeiten / Notizen',
		noteLink: 'Benachrichtigung / Verknüpfung',
		linking: 'Verknüpfung',
		noteType: '@:entity.notestype.name',
		author: 'Autor',
		start: 'Beginn',
		end: 'Ende',
		addressDescription: 'Adressbeschreibung',
		dataProcessingResponsibility:
			'Sie sind Verantwortlicher der Datenverarbeitung. Bitte prüfen Sie daher eigenständig, ob Sie diese Nachricht aus datenschutzrechtlicher Sicht auch per E-Mail an die Empfänger senden dürfen, z.B. zum Zwecke der Erfüllung des Verwaltervertrags. Nutzer, die sich bei Mobile freigeschaltet haben und solche, die sich nicht freigeschaltet haben (kenntlich gemacht durch das rote !), könnten sich hierbei unterscheiden. Bitte fragen Sie im Zweifel Ihre datenschutzrechtlichen Berater. Dieser Hinweis stellt keine datenschutzrechtlichen Rat dar.',
		noDispatch: 'Kein Versand',
		mobileUsersActivated: 'Freigeschaltete MOBILE Nutzer',
		sendingDisabled:
			'Der Versand von Benachrichtigungen ist deaktiviert, bitte aktivieren Sie diesen zuerst um die Funktion zu verwenden',
		recipient: '@:common.recipient',
		addressAccess:
			'Um eine Hausverwaltung / Adresse als Autor auswählen zu können, muss diese über einen gültigen Benutzerzugang verfügen.',
		documentSizeWarning:
			'Die Gesamtgröße der Dokumente übersteigt 20 MB. Dokumente werden deswegen nicht als Anhang mit der Benachrichtigung versendet!',
		editNoteRecipient: 'Notizempfänger bearbeiten',
		transfer: 'Übertrag',
		transferNotice:
			'Mit der Auswahl „Übertrag ins Z.I.S.“ wird die Auswahl von mindestens einem Objekt notwendig, außerdem ist es Ihnen im nächsten Schritt nur möglich, ein Dokument auszuwählen.',
		transferButton: 'Übertrag ins Z.I.S. HP Genesis',
		documentsWithObjects:
			'Dokumente mit den angegebenen Objekten @.lower:{action}',
	},
}
